const SHOPPING_TOOLS_PAYMENT_ESTIMATOR = () => ({
    page: {
        siteSection: 'shopping tools',
        hierarchy: 'shopping tools:payment calculator',
        tool: 'event:payment calculator',
        toolDescriptor: 'shopping tools:payment calculator',
    },
    user: {
        leadType: 'shopping tools:payment calculator',
    },
    event: {
        action: 'Payment Estimate',
    },
    onclick: {
        onclick: 'shopping tools:payment calculator:estimate',
        onclickLinkName: 'dc:shopping tools:payment calculator:content action',
    },
});

const VDP_PAYMENT_ESTIMATOR = ({ vehicleCondition, make, model, year }, isCommercial) => ({
    page: {
        siteSection: 'search inventory',
        hierarchy: `shopping tools:payment estimator:${vehicleCondition}:${make.name} ${model.name}`,
        tool: 'event:payment calculator',
        toolDescriptor: 'vehicle details:payment estimator',
    },
    onclick: {
        onclick: `${vehicleCondition}:si:${
            isCommercial ? 'commercial:' : ''
        }vehicle details:payment estimator:calculate`,
        onclickLinkName: `dc:${vehicleCondition}:si:${
            isCommercial ? 'commercial:' : ''
        }vehicle details:payment estimator:content action:${make.name} ${model.name}`,
    },
    vehicle: {
        modelYear: year,
        nameplate: `${make.name} ${model.name}`,
    },
    user: {
        leadType: 'vdp:payment estimator',
    },
    event: {
        action: 'Payment Estimate',
    },
});

const GARAGE_CHECKOUT_CTA = ({ model, make, year }) => ({
    page: {
        pageName: `dc:garage:vrfq:${make.name} ${model.name}`,
        siteSection: 'garage',
        hierarchy: 'garage',
        pageNameNoVehicle: 'dc:garage:vrfq',
        variantName: 'global-load',
    },
    vehicle: {
        modelYear: year,
        nameplate: `${make.name} ${model.name}`,
    },
});

const GARAGE_OVERLAY_CTA = (actionType, { model = '', make = '', year = '' }) => ({
    onclick: {
        onclick: `garage:content:${actionType}`,
        onclickLinkName: 'dc:garage:content:action',
    },
    vehicle: {
        modelYear: year, // modelYear only for delete
        nameplate: make && model && `${make?.name} ${model?.name}`, // nameplate only for delete
    },
});

const GARAGE_TRANSACTION_BAR = () => ({
    page: {
        pageName: 'dc:garage',
        siteSection: 'garage',
        hierarchy: 'garage',
        pageNameNoVehicle: 'dc:garage',
    },
    vehicle: {
        modelYear: '',
        nameplate: '',
    },
});

const TRADE_IN_TRANSACTION_BAR = ({ make, model, year }) => ({
    page: {
        pageName: 'dc:trade in:<overlay>',
        siteSection: 'trade in',
        hierarchy: 'trade in',
        pageNameNoVehicle: 'dc:trade in:<overlay>',
    },
    vehicle: {
        modelYear: year,
        nameplate: `${make} ${model}`,
    },
});

const SEARCH_RESULT_PAGE_SORT_BY = (inventoryType, sortBy) => ({
    onclick: {
        onclick: `${inventoryType}:si:vls:sort by:${sortBy}`,
        onclickLinkName: `dc:${inventoryType}:si:vls:content:action`,
    },
});

const COMMERCIAL_SEARCH_RESULT_PAGE_SORT_BY = (inventoryType, sortBy) => ({
    onclick: {
        onclick: `${inventoryType}:si:commercial:vls:sort by:${sortBy}`,
        onclickLinkName: `dc:${inventoryType}:si:commercial:vls:content:action`,
    },
});

const SEARCH_RESULT_PAGE_FILTER_BY = (inventoryType, filterType, value) => ({
    onclick: {
        onclick: `${inventoryType}:si:vls:filter:${filterType}:${value}`,
        onclickLinkName: `dc:${inventoryType}:si:vls:content:action`,
    },
});

const SEARCH_RESULT_PAGE_OTHER_ACTIONS = (inventoryType, actionType) => ({
    onclick: {
        onclick: `${inventoryType}:si:vls:${actionType}`,
        onclickLinkName: `dc:${inventoryType}:si:vls:content:action`,
    },
});

const COMMERCIAL_SEARCH_RESULT_PAGE_OTHER_ACTIONS = (inventoryType, actionType) => ({
    onclick: {
        onclick: `${inventoryType}:si:commercial:vls:${actionType}`,
        onclickLinkName: `dc:${inventoryType}:si:commercial:vls:content:action`,
    },
});

const TRANSACTION_BAR_CTA = (transcationType, cta) => ({
    onclick: {
        onclick: `help:my transaction:${transcationType}:content:${cta}`,
        onclickLinkName: `dc:help:my transaction:${transcationType}:content:action`,
    },
});

const CATALOG_PAGE_FILTERS_RESET = () => ({
    onclick: {
        onclick: 'showroom:content:{reset}',
        onclickLinkName: 'dc:showroom:content:action',
    },
});

const CATALOG_PAGE_BODY_STYLE = (bodyStyleType) => ({
    onclick: {
        onclick: `showroom:content:{body style:${bodyStyleType}}`,
        onclickLinkName: 'dc:showroom:content:action',
    },
});

const CATALOG_PAGE_SORT_LIST = (sortBy) => ({
    onclick: {
        onclick: `showroom:content:{sort:${sortBy}}`,
        onclickLinkName: 'dc:showroom:content:action',
    },
});

const BUY_ONLINE_CTA = () => ({
    page: {
        pageName: 'dc:buy online:thank you',
        siteSection: 'buy online',
        hierarchy: 'buy online:thank you',
        pageNameNoVehicle: 'dc:buy online:thank you',
        tool: 'default form',
        toolDescriptor: 'buy online',
    },
    user: {
        leadType: 'buy online',
    },
    event: {
        action: 'lead submitted',
    },
});

const CHECKOUT_DEPOSIT_SUBMIT = (actionType, { make, model, year, modelTrim, engine, bodyColour, sellingPrice }) => ({
    page: {
        pageName: `dc:garage:vrfq:thank you:${make} ${model}}`,
        siteSection: 'garage',
        hierarchy: 'garage',
        pageNameNoVehicle: 'dc:garage:vrfq:thank you',
        tool: 'event:get quote',
        toolDescriptor: 'garage:get quote',
    },
    vehicle: {
        modelYear: year,
        nameplate: `${make} ${model}`,
        bodyModelTrim: modelTrim,
        extIntColorCode: bodyColour?.colorCode,
        engineTrans: engine,
        price: sellingPrice,
    },
    user: {
        leadType: 'garage:vrfq',
    },
    event: {
        action: actionType, // lead submitted|Vehicle Quote|tool
    },
});

const MY_TRANSACTION_OVERLAY = (transactionType) => ({
    page: {
        pageName: `dc:help:my transaction:${transactionType}`,
    },
});

const PRICE_QUOTE_CTA = () => ({
    page: {
        pageName: 'dc:shopping tools:quick quote:thank you',
        siteSection: 'shopping tools',
        hierarchy: 'shopping tools:quick quote',
        pageNameNoVehicle: 'dc:shopping tools:quick quote:thank you',
        tool: 'event:quick quote',
        toolDescriptor: 'shopping tools:quick quote',
    },
    user: {
        leadType: 'shopping tools:quick quote',
    },
    event: {
        action: 'Quick Quote',
    },
});

const LOGIN = () => ({
    page: {
        pageName: 'dc:login',
        siteSection: 'account',
        hierarchy: 'account:login',
        pageNameNoVehicle: 'dc:login',
    },
});

const LOGIN_CTA = (actionType) => ({
    onclick: {
        onclick: `login:content:${actionType}`,
        onclickLinkName: 'dc:login:content:action',
    },
});

const CREATE_AN_ACCOUNT = () => ({
    page: {
        pageName: 'dc:create an account',
        siteSection: 'account',
        hierarchy: 'account:create an account',
        pageNameNoVehicle: 'dc:create an account',
    },
});

const CREATE_AN_ACCOUNT_CTA = (actionType) => ({
    onclick: {
        onclick: `create an account:content:${actionType}`,
        onclickLinkName: 'dc:create an account:content:action',
    },
});

const MY_ACCOUNT = () => ({
    page: {
        pageName: 'dc:my account',
        siteSection: 'account',
        hierarchy: 'account:my account',
        pageNameNoVehicle: 'dc:my account',
    },
});

const BUILDER_COMPLETION = ({ make, model, year }) => ({
    page: {
        pageName: '',
    },
    onclick: {
        onclick: 'referral:foc:bp',
        onclickLinkName: 'referral:exit',
    },
    vehicle: {
        modelYear: year,
        nameplate: `${make} ${model}`,
    },
    event: {
        action: 'Brand Referral',
    },
});

// step: trim, performance, comfort etc...
const BUILDER_STEPS = (step) => ({
    page: {
        pageName: `dc:bp:${step}`,
        hierarchy: `bp:${step}`,
        pageNameNoVehicle: `dc:bp:${step}`,
    },
});

const CHECKOUT_DEPOSIT_LOAD = () => ({
    page: {
        pageName: 'dc:buy online:checkout',
        siteSection: 'buy online',
        hierarchy: 'buy online:checkout',
        pageNameNoVehicle: 'dc:buy online:checkout',
    },
});

const CHECKOUT_FINANCING_LOAD = () => ({
    page: {
        pageName: 'dc:buy online:financing',
        siteSection: 'buy online',
        hierarchy: 'buy online:financing',
        pageNameNoVehicle: 'dc:buy online:financing',
    },
});

const CHECKOUT_PROTECTIONS_LOAD = () => ({
    page: {
        pageName: 'dc:buy online:protections',
        siteSection: 'buy online',
        hierarchy: 'buy online:protections',
        pageNameNoVehicle: 'dc:buy online:protections',
    },
});

const CHECKOUT_REVIEW_LOAD = () => ({
    page: {
        pageName: 'dc:buy online:review',
        siteSection: 'buy online',
        hierarchy: 'buy online:review',
        pageNameNoVehicle: 'dc:buy online:review',
    },
});

const VDP_ACTIONS = (vehicleCondition, actionType, { make, model }, isCommercial = false) => ({
    onclick: {
        onclick: `${vehicleCondition}:si:${isCommercial ? 'commercial:' : ''}vehicle details:${actionType}`,
        onclickLinkName: `dc:${vehicleCondition}:si:${
            isCommercial ? 'commercial:' : ''
        }vehicle details:content:action:${make} ${model}`,
    },
    page: {
        pageName: '',
        variantName: 'global-onclick',
    },
    event: {},
});

const REQUIRE_INFO_CTA = (vehicleCondition, { make, model }) => ({
    page: {
        pageName: `dc:${vehicleCondition}:si:vehicle details:vrfq:${make} ${model}`,
        siteSection: 'get quote',
        hierarchy: `shopping tools:get quote:${vehicleCondition}:${make} ${model}`,
        pageNameNoVehicle: `dc:${vehicleCondition}:si:vehicle details:vrfq`,
        variantName: 'form-submit',
    },
    event: {},
});

export default {
    SHOPPING_TOOLS_PAYMENT_ESTIMATOR,
    VDP_PAYMENT_ESTIMATOR,
    GARAGE_CHECKOUT_CTA,
    GARAGE_OVERLAY_CTA,
    GARAGE_TRANSACTION_BAR,
    TRADE_IN_TRANSACTION_BAR,
    SEARCH_RESULT_PAGE_SORT_BY,
    SEARCH_RESULT_PAGE_FILTER_BY,
    SEARCH_RESULT_PAGE_OTHER_ACTIONS,
    TRANSACTION_BAR_CTA,
    BUY_ONLINE_CTA,
    CHECKOUT_DEPOSIT_SUBMIT,
    MY_TRANSACTION_OVERLAY,
    PRICE_QUOTE_CTA,
    LOGIN,
    LOGIN_CTA,
    CREATE_AN_ACCOUNT,
    CREATE_AN_ACCOUNT_CTA,
    MY_ACCOUNT,
    BUILDER_COMPLETION,
    BUILDER_STEPS,
    CATALOG_PAGE_FILTERS_RESET,
    CATALOG_PAGE_BODY_STYLE,
    CATALOG_PAGE_SORT_LIST,
    CHECKOUT_REVIEW_LOAD,
    CHECKOUT_DEPOSIT_LOAD,
    CHECKOUT_FINANCING_LOAD,
    CHECKOUT_PROTECTIONS_LOAD,
    VDP_ACTIONS,
    COMMERCIAL_SEARCH_RESULT_PAGE_OTHER_ACTIONS,
    COMMERCIAL_SEARCH_RESULT_PAGE_SORT_BY,
    REQUIRE_INFO_CTA,
};
